import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Row, Col } from "reactstrap";

// hooks
import { useRedux } from "../../hooks/index";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import withRouter from "../../components/withRouter";

// actions
// import { logoutUser } from "../../redux/actions";
import { clearCurrentUser } from "../../redux/profile2/p2_reducer";
import { createSelector } from "reselect";
import { LogDb, Utils } from "helpers/utils";

const LogoutEx = (props: any) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      isInFrame: layout.isInFrame,
    })
  );
  const location = useLocation();

  const { isInFrame } = useAppSelector(errorData);

  useEffect(() => {
    // dispatch(logoutUser());
    // console.log('clear current user');
    const compName = "LogoutEx";
    const queryString = location.search;

    dispatch(clearCurrentUser(`${compName} Component`, `${compName}(${queryString}) component render and clearCurrentUser on dispatch`));
  }, [dispatch]);

  // if (isUserLogout) {
  //   return <Redirect to="/auth-login" />;
  // }

  return (
    <NonAuthLayoutWrapper lightBg>
      <Row className="justify-content-center my-auto">
        {!isInFrame && (
          <Col sm={8} lg={6} xl={5} className="col-xxl-4">
            <div className="py-md-5 py-4 text-center">
              <div className="avatar-xl mx-auto">
                <div className="avatar-title bg-soft-primary text-primary h1 rounded-circle">
                  <i className="bx bxs-user"></i>
                </div>
              </div>
              <div className="mt-4 pt-2">
                <h5>You are Logged Out</h5>
                <p className="text-muted font-size-15">
                  ขอบคุณสำหรับการใช้งาน{" "}
                  <span className="fw-semibold text-dark">{process.env.REACT_APP_NAME}</span>
                </p>
                <div className="mt-4">
                  <Link
                    to="/auth-login"
                    className="btn btn-primary w-100 waves-effect waves-light"
                  >
                    ล็อกอิน
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        )}
        {isInFrame && (
          <Col className="text-danger align-center text-center">
            <span style={{ fontSize: "60px" }}>🧩</span><br />
            ทำงานในโหมด plug in<br />กำลังรอการยืนยันตัวตน
          </Col>
        )}
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default withRouter(LogoutEx);
